import React, { lazy } from 'react';
/**
 * PERF: This component is intentionally inert. The original implementation
 * tracked scroll position and computed `getBoundingClientRect()` on every
 * scroll frame to toggle an `isVisible` flag — but the component returns
 * `null`, so the visible result was nothing. We removed the scroll listener
 * and state updates (pure CPU + GC waste on mobile) without altering the
 * rendered output. The component stays in the tree so the LandingPage and
 * lazy-import graph remain unchanged.
 */
export function StickyCTA() {
  return null;
}